// import throttle from '../utilities/throttle';

export default function FixedHeader() {
  return {
    init: () => {
      const header = document.querySelector('header');
      if (!header) return;

      window.addEventListener(
        'scroll',
        () => {
          if (window.scrollY > 100) {
            document.documentElement.classList.add('w-is-scrolled');
          } else {
            document.documentElement.classList.remove('w-is-scrolled');
          }
        },
        { passive: true }
      );
    }
  };
}
